import styled from '@emotion/styled'

export const PanelsContainerStyled = styled.div({
  '> div:not(:last-child)': {
    marginBottom: '2px',
  },
})
